import { render, staticRenderFns } from "./FormTabla.vue?vue&type=template&id=371175f4&scoped=true"
import script from "./FormTabla.vue?vue&type=script&lang=js"
export * from "./FormTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371175f4",
  null
  
)

export default component.exports